import { render, staticRenderFns } from "./CandidateLoginAlert.vue?vue&type=template&id=10f0a48a"
import script from "./CandidateLoginAlert.vue?vue&type=script&lang=js"
export * from "./CandidateLoginAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports